import { IframelyMedia } from '@prismamedia/one-components';
import {
  ItemSerialized,
  ItemType,
  MEDIA_TYPES_LABEL,
  ViewMode,
} from 'components/MediaInput/MultimediaPlugin/types';

interface MultimediaPluginState<Item = ItemSerialized> {
  isBusy: boolean;
  isFullFilled: boolean;
  isLoading: boolean;
  isOpen: boolean;
  items: Item[];
  medias: IframelyMedia[];
  pluginType: MEDIA_TYPES_LABEL;
  selectedItems: Item[];
  value: string;
  viewMode: ViewMode;
  suggestedItems: null | Item[];
}

enum MultimediaPluginActionTypeEnum {
  SET_BUSY = 'SET_BUSY',
  SET_INITIAL_STATE = 'SET_INITIAL_STATE',
  SET_IS_FULLFILLED = 'SET_IS_FULLFILLED',
  SET_IS_OPEN = 'SET_IS_OPEN',
  SET_ITEMS = 'SET_ITEMS',
  SET_SUGGESTED_ITEMS = 'SET_SUGGESTED_ITEMS',
  SET_LOADING = 'SET_LOADING',
  SET_MEDIAS = 'SET_MEDIAS',
  SET_PLUGIN_TYPE = 'SET_PLUGIN_TYPE',
  SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS',
  SET_VALUE = 'SET_VALUE',
  SET_VIEW_MODE = 'SET_VIEW_MODE',
}

interface MultimediaPluginActionType<T> {
  type: MultimediaPluginActionTypeEnum;
  payload?: T;
}

export const initialState: MultimediaPluginState<any> = {
  isBusy: false,
  isFullFilled: false,
  isLoading: false,
  isOpen: false,
  items: [],
  medias: [],
  pluginType: '' as MEDIA_TYPES_LABEL,
  selectedItems: [],
  value: '',
  viewMode: ViewMode.LIST,
  suggestedItems: null,
};

export const actions = {
  setIsOpen: (isOpen: boolean) => ({
    type: MultimediaPluginActionTypeEnum.SET_IS_OPEN,
    payload: isOpen,
  }),
  setBusy: (isBusy: boolean) => ({
    type: MultimediaPluginActionTypeEnum.SET_BUSY,
    payload: isBusy,
  }),
  setIsFullFilled: (isFullFilled: boolean) => ({
    type: MultimediaPluginActionTypeEnum.SET_IS_FULLFILLED,
    payload: isFullFilled,
  }),
  setValue: (value: string) => ({
    type: MultimediaPluginActionTypeEnum.SET_VALUE,
    payload: value,
  }),
  setItems: (items: ItemType<any>[]) => ({
    type: MultimediaPluginActionTypeEnum.SET_ITEMS,
    payload: items,
  }),
  setSuggestedItems: (suggestedItems: null | ItemType<any>[]) => {
    return {
      type: MultimediaPluginActionTypeEnum.SET_SUGGESTED_ITEMS,
      payload: suggestedItems,
    };
  },
  setLoading: (isLoading: boolean) => ({
    type: MultimediaPluginActionTypeEnum.SET_LOADING,
    payload: isLoading,
  }),
  setMedias: (medias: IframelyMedia[]) => ({
    type: MultimediaPluginActionTypeEnum.SET_MEDIAS,
    payload: medias,
  }),
  setChangePlugin: (pluginType: string) => ({
    type: MultimediaPluginActionTypeEnum.SET_PLUGIN_TYPE,
    payload: pluginType,
  }),
  setViewMode: (viewMode: ViewMode) => ({
    type: MultimediaPluginActionTypeEnum.SET_VIEW_MODE,
    payload: viewMode,
  }),
  setSelectedItems: (selectedItems: ItemType<any>[]) => ({
    type: MultimediaPluginActionTypeEnum.SET_SELECTED_ITEMS,
    payload: selectedItems,
  }),
  setInitialState: () => ({
    type: MultimediaPluginActionTypeEnum.SET_INITIAL_STATE,
  }),
};

export const reducer = (
  state: MultimediaPluginState<any>,
  action: MultimediaPluginActionType<any>,
): MultimediaPluginState<any> => {
  switch (action.type) {
    case MultimediaPluginActionTypeEnum.SET_BUSY:
      return { ...state, isBusy: action.payload };
    case MultimediaPluginActionTypeEnum.SET_IS_FULLFILLED:
      return { ...state, isFullFilled: action.payload };
    case MultimediaPluginActionTypeEnum.SET_IS_OPEN:
      return { ...state, isOpen: action.payload };
    case MultimediaPluginActionTypeEnum.SET_INITIAL_STATE:
      return { ...initialState };
    case MultimediaPluginActionTypeEnum.SET_VALUE:
      return { ...state, value: action.payload };
    case MultimediaPluginActionTypeEnum.SET_ITEMS:
      return { ...state, items: action.payload };
    case MultimediaPluginActionTypeEnum.SET_SUGGESTED_ITEMS:
      return { ...state, suggestedItems: action.payload };
    case MultimediaPluginActionTypeEnum.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case MultimediaPluginActionTypeEnum.SET_MEDIAS:
      return { ...state, medias: action.payload };
    case MultimediaPluginActionTypeEnum.SET_PLUGIN_TYPE:
      return { ...state, pluginType: action.payload };
    case MultimediaPluginActionTypeEnum.SET_VIEW_MODE:
      return { ...state, viewMode: action.payload };
    case MultimediaPluginActionTypeEnum.SET_SELECTED_ITEMS:
      return { ...state, selectedItems: action.payload };
    default:
      return state;
  }
};
